import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useStratifiedProductionChartsDataContext } from './hooks/useStratifiedProductionChartsDataContext';

export const AnnualEvolutionServices = () => {
    const { chartData } = useStratifiedProductionChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Atendimentos no Município'}
            horizontal={false}
            subtitles={chartData?.annualEvolutionServices?.map((item) => item.description)}
            values={chartData?.annualEvolutionServices?.map((item) => item.total  ||  0)}
        />
    );
};
